// src/app/core/services/subscriptions.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {firstValueFrom, Observable, of, Subject, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {Subscriptions} from "../model/subscriptions.models";
import {SubscriptionInfo} from "../model/subscription-nfo";

@Injectable({ providedIn: 'root' })
export class SubscriptionsService {

    private readonly baseUrl = '/api/sipo/subscriptions';

    refreshCreditValue: Subject<any> = new Subject();

    constructor(private http: HttpClient) {}

    /** GET /api/sipo/subscriptions  – current Users subcriptions */
    getCurrentUsersSubscriptions(): Observable<Subscriptions> {
        return this.http
            .get<Subscriptions>('/api/sipo/subscriptions')
            .pipe(catchError(this.handleError));
    }

    /** POST /api/sipo/subscriptions  – erstellt Abo für aktuellen User */
    createUserSubscriptions(payload: Subscriptions): Observable<Subscriptions> {
        return this.http
            .post<Subscriptions>(this.baseUrl, payload)
            .pipe(catchError(this.handleError));
    }

    /** PUT /api/sipo/subscriptions  – aktualisiert Abo des aktuellen Users */
    updateUserSubscriptions(payload: Partial<Subscriptions>): Observable<Subscriptions> {
        return this.http
            .put<Subscriptions>(this.baseUrl, payload)
            .pipe(catchError(this.handleError));
    }

    /** DELETE /api/sipo/subscriptions  – löscht Abo des aktuellen Users */
    deleteUserSubscriptions(): Observable<void> {
        return this.http
            .delete<void>(this.baseUrl)
            .pipe(catchError(this.handleError));
    }

    private handleError = (error: HttpErrorResponse) => {
        // Hier könntest du zentral loggen / an Monitoring senden
        return throwError(() => error);
    };

    async getSubscriptionInfo(): Promise<SubscriptionInfo> {
        return await firstValueFrom(
            this.http.get<SubscriptionInfo>(this.baseUrl+"/info")
        );
    }
}
